const LOGIN = 'LOGIN'
const LOGOUT = 'LOGOUT'
const GET_USER = 'GET_USER'
const GET_USER_POST = 'GET_USER_POST'

export { LOGIN, LOGOUT, GET_USER, GET_USER_POST }
